export default "__VITE_ASSET__CFB7LIKp__"